module.exports = "/images/aerial-10.jpg";